/* ============================================================================
   haiku-stickycta — park the bar when the footer arrives

   "Stops at the beginning of the footer" is exactly an intersection test: the
   moment the footer's top edge crosses into the viewport, the bar leaves.

   WHY NOT position: sticky. Sticky stops at the end of its CONTAINING BLOCK,
   and here the footer is a child of #main alongside every other section — so
   a sticky element in that flow would run past the footer, not stop at it.
   Fixing the containing block would mean restructuring the theme's page
   wrapper. An observer reads the same intent off the element that actually
   matters.

   FAIL-SAFE. No observer support, or no footer found, leaves the bar visible
   rather than hidden. A CTA that overlaps the footer is a blemish; a CTA that
   silently never appears is a missing route to the only thing for sale.
   ========================================================================== */
(function () {
  'use strict';

  /* ── the product page: ADD TO CART while the real button is off screen ──
     (2026-10-24). The bar presses the page's one real button, so the cart
     form stays singular. It rises only while that button AND the footer are
     both out of view, and steps aside for good once <product-form> reports
     the line accepted (`add-to-cart`, the event product-editorial.js already
     listens for): a one-of-one piece cannot be added twice. If the real button
     is missing or disabled the bar never rises at all — the opposite of the
     homepage's fail-safe, because a buy button that cannot buy is worse than
     none. */
  function bootBuy(bar) {
    var root = document.documentElement;
    var real = document.querySelector('.pe__buy .product__add-to-cart');
    var link = bar.querySelector('[data-hs-link]');
    if (!real || !link || typeof window.IntersectionObserver !== 'function') return;

    /* The header's bag, cloned like the wardrobe icon (never the count badge). */
    var cartIcon = document.querySelector('.header .hi-icon--cart');
    if (cartIcon) {
      link.insertBefore(cartIcon.cloneNode(true), link.firstChild);
    }
    link.classList.add('is-glyph');

    var realOut = false;
    var footerOut = true;
    var done = false;

    var sync = function () {
      var up = realOut && footerOut && !done && !real.disabled;
      if (up) {
        bar.removeAttribute('data-hs-parked');
        root.classList.add('hs-cta-on');
      } else {
        bar.setAttribute('data-hs-parked', '');
        root.classList.remove('hs-cta-on');
      }
    };

    new window.IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) realOut = !entries[i].isIntersecting;
      sync();
    }, { threshold: 0 }).observe(real);

    var footer = document.querySelector('.shopify-section-group-footer-group');
    if (footer) {
      new window.IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) footerOut = !entries[i].isIntersecting;
        sync();
      }, { threshold: 0 }).observe(footer);
    }

    var pf = real.closest ? real.closest('product-form') : null;
    if (pf) {
      pf.addEventListener('add-to-cart', function () { done = true; sync(); });
    }

    link.addEventListener('click', function () {
      if (real.disabled) return;
      real.click();
    });
  }

  function boot() {
    var bar = document.querySelector('[data-hs-cta]');
    if (!bar) return;
    if (bar.hasAttribute('data-hs-buy')) { bootBuy(bar); return; }

    /* THE LABEL IS THE HEADER'S OWN ARTWORK, cloned rather than duplicated.
       The wordmark is ~63KB of path data; a second copy in this file would be
       free to drift from the header the first time the mark is redrawn. If the
       header link is absent the plain-text fallback simply stays. */
    var link = bar.querySelector('[data-hs-link]');
    var src = document.querySelector('[data-hn="wardrobe"]');
    if (link && src) {
      var icon = src.querySelector('.hi-icon');
      var word = src.querySelector('.hn-word');
      if (icon && word) {
        link.appendChild(icon.cloneNode(true));
        link.appendChild(word.cloneNode(true));
        /* Only now is the fallback redundant — the class is what hides it, so
           it is never hidden before something has replaced it. */
        link.classList.add('is-glyph');
      }
    }

    /* The section-group class is stable across theme-editor edits; the id on
       that element carries a generated suffix that is not. */
    var footer = document.querySelector('.shopify-section-group-footer-group');
    if (!footer || typeof window.IntersectionObserver !== 'function') return;

    var root = document.documentElement;

    /* The bar's own state lives on the bar; the class on <html> exists so the
       rest of the page can respond to it — the bottom gradient grows to carry
       the bar, and the back-to-top steps out from under it. CSS has no way to
       look upward from the bar to reach either. */
    var setParked = function (parked) {
      if (parked) {
        bar.setAttribute('data-hs-parked', '');
        root.classList.remove('hs-cta-on');
      } else {
        bar.removeAttribute('data-hs-parked');
        root.classList.add('hs-cta-on');
      }
    };

    setParked(false);

    var io = new window.IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) setParked(entries[i].isIntersecting);
    }, { threshold: 0 });

    io.observe(footer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
}());
